import React, { useState, useEffect } from 'react';
import apiService from '../../services/api';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCalendar, FiInfo } = FiIcons;

const ReleaseNotes = () => {
  const [notes, setNotes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchNotes = async () => {
      try {
        const res = await apiService.getReleaseNotes();
        if (res.status === 'success') {
          const sorted = res.data.sort((a, b) => new Date(b.date) - new Date(a.date));
          setNotes(sorted);
        }
      } catch (error) {
        console.error('Error fetching release notes:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchNotes();
  }, []);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-primary"></div>
      </div>
    );
  }

  return (
    <div className="max-w-4xl mx-auto p-6">
      <div className="mb-8 flex items-center">
        <div className="p-3 bg-brand-primary/20 rounded-lg mr-4">
          <SafeIcon icon={FiInfo} className="w-8 h-8 text-brand-secondary" />
        </div>
        <div>
          <h1 className="text-3xl font-bold text-brand-dark">Release Notes</h1>
          <p className="mt-1 text-gray-600">Neuigkeiten und Updates zur Anwendung</p>
        </div>
      </div>

      <div className="space-y-8">
        {notes.length > 0 ? (
          notes.map((note) => (
            <div key={note.id} className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
              <div className="p-6 border-b border-gray-100 bg-gray-50 flex justify-between items-center flex-wrap gap-2">
                <h2 className="text-xl font-bold text-brand-dark">{note.title}</h2>
                <div className="flex items-center text-gray-500 text-sm bg-white px-3 py-1 rounded-full border border-gray-200">
                  <SafeIcon icon={FiCalendar} className="w-4 h-4 mr-2" />
                  {new Date(note.date).toLocaleDateString('de-DE', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                  })}
                </div>
              </div>
              <div 
                className="p-6 prose prose-blue max-w-none"
                dangerouslySetInnerHTML={{ __html: note.description }}
              />
            </div>
          ))
        ) : (
          <div className="text-center py-12 bg-white rounded-lg border border-gray-200 shadow-sm">
            <SafeIcon icon={FiInfo} className="w-12 h-12 text-gray-300 mx-auto mb-4" />
            <h3 className="text-lg font-medium text-brand-dark">Keine Release Notes gefunden</h3>
            <p className="mt-2 text-gray-500">Es wurden noch keine Updates veröffentlicht.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ReleaseNotes;